<template>
<div class="content">
    <toolbar v-bind:selection="toolbar" title="Nueva reina" />


        <v-form ref="form" v-model="valid" lazy-validation>

            <v-text-field
                    v-model="infoform.name"
                    color="orange"
                    label="Nombre de la reina*"
                    :rules="nameRules"

            ></v-text-field>

            <!--div class="row">
                <div class="col-d-10"><b>Marcada</b></div>
                <div class="col-d-2">
                    <v-switch
                            color="orange"
                            v-model="infoform.marked"
                            inset
                    ></v-switch>

                </div>
            </div-->

            <v-select
                    v-model="infoform.year"
                    class="form-group"
                    color="orange"
                    :items="optionsYears"
                    label="Año de nacimiento*"
                    data-vv-name="infoform.year"
                    @change="changeYear()"
                    required
            ></v-select>

            <b>Color</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="color in optionsColor" :key="color.value"  style="width:auto">
                    <input type="radio" v-model="infoform.color" :id="color.value" :value="color.value">
                    <label class="btn" :for="color.value">{{color.text}}</label>
                </div>
            </div>

            <v-text-field
                    v-model="infoform.race"
                    color="orange"
                    label="Raza"
            ></v-text-field>

            <b>Origen</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="origin in optionsOrigin" :key="origin.value" style="width:auto">
                    <input type="radio" v-model="infoform.origin" :id="origin.value" :value="origin.value">
                    <label class="btn" :for="origin.value">{{origin.text}}</label>
                </div>


            </div>

            <!--        <v-select
                            v-model="infoform.origin"
                            class="form-group"
                            color="orange"
                            :items="optionsOrigin"
                            label="Origen*"
                            data-vv-name="infoform.origin"
                            required
                    ></v-select>


                    <p for="description" class="">Descripción</p>
                    <textarea name="description" rows="5" id="description" class="form-control"
                              placeholder="Otros tipos, notas, información adicional"
                              v-model="infoform.description"></textarea>
        -->

            <p><b>Descripción</b></p>
            <v-col class="col" cols="12" md="6">
                <v-textarea
                        solo
                        name="description"
                        label="Otros tipos, notas, información adicional"
                        v-model="infoform.description"
                ></v-textarea>
            </v-col>


            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>

            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                Aceptar
            </v-btn>

            <v-btn class="mr-4" @click="reset">
                Limpiar
            </v-btn>

        </v-form>

</div>

</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"
import axios from "axios";

export default {
    name: 'queen-nueva',
    components: {
        toolbar,

        loading,
    },
    data() {
        return {
            toolbar: {
              return: '0',
            },

            valid: true,

            nameRules: [
                v => !!v || 'Requerido',
                v => (v && v.length <= 25) || 'Debe ser inferior a 25 caracteres',
            ],

            isloading:'',

            /* mensaje resultado form */
            alertForm:'success',
            responseform:'',
            alert: false,

            optionsOrigin: [
              { text: 'Comprada', value: 'comprada' },
              { text: 'Producción propia', value: 'propia' },
              { text: 'Otros', value: 'otros' }
            ],

            optionsYears: [
              { text: new Date().getFullYear(), value: new Date().getFullYear() },
              { text: new Date().getFullYear()-1, value: new Date().getFullYear()-1 },
              { text: new Date().getFullYear()-2, value: new Date().getFullYear()-2 },
              { text: new Date().getFullYear()-3, value: new Date().getFullYear()-3 },
              { text: new Date().getFullYear()-4, value: new Date().getFullYear()-4 },
            ],

            optionsColor: [
              { text: 'Sin marcar', value: 'sin marcar' },
              { text: 'Blanco 1 o 6', value: 'blanco' },
              { text: 'Amarillo 2 o 7', value: 'amarillo' },
              { text: 'Rojo 3 o 8', value: 'rojo' },
              { text: 'Verde 4 o 9', value: 'verde' },
              { text: 'Azul 5 o 0', value: 'azul' }
            ],


            infoform: {
                name: '',
                year: new Date().getFullYear(),
                color:'sin marcar',
                race: '',
                origin: 'propia',
                description: ''
            }
        }
    },created() {

        auth.getUserLogged()

        var cadena = ""+new Date().getFullYear()
        var ultimoCaracter = cadena.charAt(cadena.length - 1)

        if(ultimoCaracter === '1' || ultimoCaracter === '6' ){
            this.infoform.color = 'blanco'
        }else if(ultimoCaracter === '2' || ultimoCaracter === '7' ){
            this.infoform.color = 'amarillo'
        }else if(ultimoCaracter === '3' || ultimoCaracter === '8' ){
            this.infoform.color = 'rojo'
        }else if(ultimoCaracter === '4' || ultimoCaracter === '9' ){
            this.infoform.color = 'verde'
        }else if(ultimoCaracter === '5' || ultimoCaracter === '0' ){
            this.infoform.color = 'azul'
        }


    },methods:{

        changeYear(){

            var cadena = ""+this.infoform.year
            var ultimoCaracter = cadena.charAt(cadena.length - 1)

            if(ultimoCaracter === '1' || ultimoCaracter === '6' ){
                this.infoform.color = 'blanco'
            }else if(ultimoCaracter === '2' || ultimoCaracter === '7' ){
                this.infoform.color = 'amarillo'
            }else if(ultimoCaracter === '3' || ultimoCaracter === '8' ){
                this.infoform.color = 'rojo'
            }else if(ultimoCaracter === '4' || ultimoCaracter === '9' ){
                this.infoform.color = 'verde'
            }else if(ultimoCaracter === '5' || ultimoCaracter === '0' ){
                this.infoform.color = 'azul'
            }

        },
            validate () {
                this.$refs.form.validate()
                if(this.$refs.form.validate()){

                    this.alert = false
                    this.isloading = true
                    axios.post('https://appws.panimiel.com/new/index.php/api/queens', this.infoform)
                         .then((response) => {
                         this.responseform = response.data
                         this.alertForm = 'success'

                         this.isloading=''

                         this.alert = true
                    })
                    .catch((error) => {
                        this.alertForm = 'error',
                        this.isloading=''

                        if (error.response.status != 500){
                            this.responseform = error.response.data
                        }else{
                            this.responseform = 'Error, no ha sido posible insertar la reina.'
                        }
                         this.alert = true

                 })
                }
            },
          reset () {
            this.$refs.form.reset()
          },
    }
}
</script>

<style scoped lang="scss">

</style>
